<mat-card style="padding: 0px;">
  <nav class="product-tabs" aria-label="Produtos SRM, SRP, PSRM e PSC">
      <a
        class="product-tab"
        [routerLink]="['/srm/municipio', ufSelecionada || 'BR']"
        [queryParams]="currentQueryParams"
      >
        SRM
      </a>
      <a
        class="product-tab"
        [routerLink]="['/srp/municipio', ufSelecionada || 'BR']"
        [queryParams]="currentQueryParams"
      >
        SRP
      </a>
      <a
        class="product-tab active"
        [routerLink]="['/spr/municipio', ufSelecionada || 'BR']"
        [queryParams]="currentQueryParams"
      >
        PSRM
      </a>
      <a
        class="product-tab"
        [routerLink]="['/spc/municipio', ufSelecionada || 'BR']"
        [queryParams]="currentQueryParams"
      >
        PSC
      </a>
    </nav>

  <mat-card-header>
    <mat-card-title>Persistência de Seca Relativa Máxima</mat-card-title>
  </mat-card-header>

  <mat-progress-bar mode="indeterminate" [class.show]="loading" [class.hide]="!loading"></mat-progress-bar>
  <mat-divider></mat-divider>
  <mat-progress-bar mode="indeterminate" [class.show]="loading" [class.hide]="!loading"></mat-progress-bar>

  <mat-card-content>

    <div class="selector-layout">
      <div class="selector">
        <mat-form-field>
          <mat-label>Filtrar por Estado</mat-label>
          <mat-select [value]="ufSelecionada" (selectionChange)="navegarParaUf($event.value)">
            <mat-option *ngFor="let uf of ufs" [value]="uf.sigla">
              {{ uf.nome }} - {{ uf.sigla }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Mês/Ano</mat-label>
          <mat-select [(value)]="dataSelecionada" (selectionChange)="onDataChange()">
            <mat-option *ngFor="let data of datas" [value]="data">
              {{ data }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <mat-card class="description-card">
        <mat-card-content>
          <p>A <b>Persistência de Seca Relativa Máxima (PSRM)</b> representa, para cada município e em cada mês de referência, a continuidade, ao longo do tempo, da condição indicada pela Seca Relativa Máxima (SRM).
A PSRM contabiliza o número de meses consecutivos em que a SRM permanece inalterada no município. Quando há mudança da categoria de SRM de um mês para o outro, a contagem é reiniciada aparecendo na PSRM a classificação "Sem Persistência".</p>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="cards-row">
      <mat-card class="card card--small">
        <mat-card-title>País</mat-card-title>
        <div class="ufs">
          <!-- país -->
          <a
            class="uf-chip"
            *ngFor="let p of paises"
            [routerLink]="['/spr/municipio', p.sigla]"
            [queryParams]="currentQueryParams"
            [class.active]="ufSelecionada === p.sigla"
          >
            {{ p.sigla }}
          </a>
        </div>
      </mat-card>

      <mat-card class="card">
        <mat-card-title>Estados (UF)</mat-card-title>
        <div class="ufs">
          <a
            class="uf-chip"
            *ngFor="let uf of ufs"
            [routerLink]="['/spr/municipio', uf.sigla]"
            [queryParams]="currentQueryParams"
            [class.active]="ufSelecionada === uf.sigla"
          >
            {{ uf.sigla }}
          </a>
        </div>
      </mat-card>
    </div>

  <div class="mapas-row">
    <app-ms-image [imagemMsUrl]="imagemMsUrl" width="80%"></app-ms-image>
    <app-srm-image [imagemSrmUrl]="imagemSrmUrl" width="80%"></app-srm-image>
    <div class="spr-image" *ngIf="imagemSprUrl as imagemUrl">
      <mat-progress-bar mode="indeterminate" *ngIf="sprImageLoading"></mat-progress-bar>
      <div class="image-wrapper">
        <div class="download-actions">
          <a
            mat-icon-button
            class="download-icon-btn"
            [href]="imagemUrl"
            target="_blank"
            rel="noopener noreferrer"
            title="Baixar imagem PNG"
            aria-label="Baixar imagem PNG">
            <mat-icon>image</mat-icon>
          </a>
          <a
            mat-icon-button
            class="download-icon-btn"
            [href]="imagemSprGpkgUrl"
            target="_blank"
            rel="noopener noreferrer"
            title="Baixar GPKG"
            aria-label="Baixar GPKG">
            
            <img src="assets/img/gpkg_icon.png"
              alt="Baixar GPKG"
              class="download-img-icon">
          </a>
        </div>

        <img
          [src]="imagemUrl"
          alt="SPR"
          class="img-responsive"
          (load)="onSprLoad()"
          (error)="onSprError()"
        />
      </div>
    </div>
  </div>
  </mat-card-content>

  <!-- <mat-card class="card">
    <mat-card-content>
      <mat-card-title>Municípios</mat-card-title>
      <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

      <div class="placeholder" *ngIf="!ufSelecionada">
        Escolha uma UF acima para carregar os municípios.
      </div>

      <ng-container *ngIf="ufSelecionada">
        <div *ngIf="dataSource.data?.length; else ufNaoImplementada">
          <div class="subtitulo">
            Listando todos os municípios da UF <strong>{{ ufSelecionada }}</strong>.
          </div>

          <div class="table-hover" #TABLE>
            <mat-table [dataSource]="dataSource" class="mat-elevation-z8">
              <ng-container matColumnDef="nome">
                <mat-header-cell *matHeaderCellDef> Município </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.nome }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="semSeca">
                <mat-header-cell *matHeaderCellDef> Sem seca </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  0
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="s0s4">
                <mat-header-cell *matHeaderCellDef> S0-S4 </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  0
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="s1s4">
                <mat-header-cell *matHeaderCellDef> S1-S4 </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  0
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="s2s4">
                <mat-header-cell *matHeaderCellDef> S2-S4 </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  0
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="s3s4">
                <mat-header-cell *matHeaderCellDef> S3-S4 </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  0
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="s4">
                <mat-header-cell *matHeaderCellDef> S4 </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  0
                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>
          </div>
        </div>

        <ng-template #ufNaoImplementada>
          <div class="placeholder">
            Tabela detalhada de municípios ainda não implementada para a UF
            <strong>{{ ufSelecionada }}</strong>.
          </div>
        </ng-template>
      </ng-container>
    </mat-card-content>
  </mat-card> -->
</mat-card>
